import React from 'react';
import PatientDetail from './Patient/Detail';
import {Requests} from './Requests';
import RequestDetail from './Requests/Detail';
import {Organizations} from './Organizations';
import OrganizationDetail from './Organizations/Detail';
import {Locations} from './Locations';
import LocationDetail from './Locations/Detail';
import {Practitioners} from './Practitioners';
import PractitionerDetail from './Practitioners/Detail';
import RequestInfo from './Medications/RequestInfo';

export const healthPageConfig = [
  {
    path: '/health/organizations',
    element: <Organizations />,
  },
  {
    path: '/health/organizations/:id',
    element: <OrganizationDetail />,
  },
  {
    path: '/health/locations',
    element: <Locations />,
  },
  {
    path: '/health/locations/:id',
    element: <LocationDetail />,
  },
  {
    path: '/health/practitioners',
    element: <Practitioners />,
  },
  {
    path: '/health/practitioners/:id',
    element: <PractitionerDetail />,
  },
  {
    path: '/health/patient',
    element: <PatientDetail />,
  },
  {
    path: '/health/requests',
    element: <Requests />,
  },
  {
    path: '/health/requests/:id',
    element: <RequestDetail />,
  },
  {
    path: '/health/medication-requests/:id',
    element: <RequestInfo />,
  },
];
